/*
 * Friki Monkey · Evey Guard (ex roarapp.js).
 * Blocks checkout from the cart drawer / cart page until every Evey event ticket in the cart
 * has its attendee data, opens the Evey attendee modal from a warning, limits numbered items
 * to 1 unit and continues to checkout once the modal is completed.
 * Config: <script id="fm-evey-config"> (theme settings). Strings: <script id="fm-strings"> → evey.
 */
(function () {
  if (window.fmEveyGuard) return;
  window.fmEveyGuard = {};

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function init() {
    var config = readJson('fm-evey-config');
    if (!config) return;
    var strings = (readJson('fm-strings') || {}).evey || {};

    var LIMITED_IDS = new Set((config.limitedIds || []).map(String));
    var EXCLUDED_IDS = new Set((config.excludedIds || []).map(String));
    var KEYWORDS = (config.keywords || []).map(function (word) {
      return String(word).toLowerCase();
    });
    var CART_JS_URL = (config.cartUrl || '/cart') + '.js';
    var CHECKOUT_URL = config.checkoutUrl || '/checkout';

    var WARNING_IDS = {
      drawer: 'evey-attendee-warning-drawer',
      cart: 'evey-attendee-warning-cart',
      fallback: 'evey-attendee-warning-fallback'
    };
    var CHECKOUT_SELECTOR = [
      'button[name="checkout"]',
      'input[name="checkout"]',
      '#CartDrawer-Checkout',
      '#checkout',
      '.cart__checkout-button',
      '.cart__ctas button[type="submit"]',
      '.cart__ctas button',
      '.cart__footer button[type="submit"]',
      '.cart-drawer__footer button[name="checkout"]',
      'a[href*="/checkout"]'
    ].join(',');
    var EVEY_MODAL_SELECTOR =
      '.evey-modal, #evey-modal, [class*="evey"][class*="modal"], [id*="evey"][id*="modal"]';
    var DRAWER_SELECTOR = 'cart-drawer, #CartDrawer, .cart-drawer, cart-notification, #cart-notification';
    var CART_PAGE_SELECTOR = '#main-cart-footer, .cart__footer-wrapper, .cart__footer, form[action$="/cart"]';
    var FOOTER_SELECTOR = '.cart__footer, .cart-drawer__footer, .drawer__footer, #main-cart-footer, .cart__footer-wrapper';
    var ROW_SELECTOR = '.cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]';
    var STEPPER_SELECTOR = 'button[name="plus"], button[name="minus"], .quantity__button';
    var QTY_INPUT_SELECTOR = 'input[name="updates[]"], .quantity__input';

    var checkoutBlocked = false;
    var checkingCart = false;
    var debounceTimer = null;
    var observerTimer = null;
    var latestCart = null;
    var finishIntentAt = 0;
    var autoNavigated = false;
    var observedRoots = new WeakSet();

    function getCart() {
      return fetch(CART_JS_URL + '?_=' + Date.now(), {
        headers: { 'Cache-Control': 'no-cache', Accept: 'application/json' }
      })
        .then(function (response) {
          return response.json();
        })
        .catch(function () {
          return { items: [] };
        });
    }

    function isVisible(element) {
      if (!element) return false;
      var rect = element.getBoundingClientRect();
      var style = window.getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    }

    function getContexts() {
      var contexts = [];
      var drawer = document.querySelector(DRAWER_SELECTOR);
      if (drawer) contexts.push({ type: 'drawer', root: drawer, warningId: WARNING_IDS.drawer });
      if (config.isCartPage) {
        var area = document.querySelector(CART_PAGE_SELECTOR) || document.querySelector('main');
        if (area) contexts.push({ type: 'cart', root: area, warningId: WARNING_IDS.cart });
      }
      return contexts;
    }

    function getContextForElement(element) {
      var found = getContexts().find(function (context) {
        return context.root.contains(element);
      });
      if (found) return found;
      var root = element.closest(DRAWER_SELECTOR + ',' + CART_PAGE_SELECTOR) || element.closest(FOOTER_SELECTOR) || element.parentElement;
      return root ? { type: 'fallback', root: root, warningId: WARNING_IDS.fallback } : null;
    }

    function getCheckoutButtons(context) {
      return Array.from(context.root.querySelectorAll(CHECKOUT_SELECTOR)).filter(function (button) {
        return !button.closest('.evey-attendee-warning');
      });
    }

    function revealEveyModal(modal) {
      modal.classList.remove('visually-hidden', 'hidden');
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      modal.style.removeProperty('display');
      modal.style.removeProperty('visibility');
      modal.style.removeProperty('opacity');
      var focusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable) {
        window.setTimeout(function () {
          focusable.focus();
        }, 100);
      }
      startTemporaryPolling(45000);
    }

    function openEveyModal(trigger) {
      var originalText = trigger ? trigger.textContent : '';
      var attempts = 0;

      function restore() {
        if (!trigger) return;
        trigger.removeAttribute('aria-busy');
        trigger.textContent = originalText || strings.guard_action || '';
      }

      function tryOpen() {
        attempts += 1;
        var modal = document.querySelector(EVEY_MODAL_SELECTOR);
        if (modal) {
          revealEveyModal(modal);
          restore();
          return true;
        }
        if (attempts === 1) {
          if (trigger) {
            trigger.setAttribute('aria-busy', 'true');
            trigger.textContent = strings.guard_loading || '';
          }
          scheduleCheckBurst();
        }
        if (attempts < 16) {
          window.setTimeout(tryOpen, 220);
          return false;
        }
        restore();
        if (strings.guard_modal_missing) window.alert(strings.guard_modal_missing);
        return false;
      }

      return tryOpen();
    }

    function productId(item) {
      return String((item && item.product_id) || '');
    }

    function isLimitedItem(item) {
      return LIMITED_IDS.has(productId(item));
    }

    function isEventItem(item) {
      if (!item || EXCLUDED_IDS.has(productId(item))) return false;
      if (item.product_type === 'Event') return true;
      var haystack = [item.product_type, item.product_title, item.title, item.url, item.handle].join(' ').toLowerCase();
      return KEYWORDS.some(function (word) {
        return word && haystack.indexOf(word) !== -1;
      });
    }

    function parseMaybeJson(value) {
      if (typeof value !== 'string') return value;
      try {
        return JSON.parse(value);
      } catch (error) {
        return value;
      }
    }

    function countEntries(value) {
      var parsed = parseMaybeJson(value);
      if (Array.isArray(parsed)) return parsed.length;
      if (parsed && typeof parsed === 'object') {
        var lists = ['attendees', 'attendee', 'guests', 'tickets', 'registrations', 'entries', 'forms', 'data'];
        for (var i = 0; i < lists.length; i += 1) {
          if (Array.isArray(parsed[lists[i]])) return parsed[lists[i]].length;
        }
        var numeric = Object.keys(parsed).filter(function (key) {
          return /^\d+$/.test(key);
        });
        if (numeric.length) return numeric.length;
      }
      return 0;
    }

    function completedCount(item) {
      var properties = (item && item.properties) || {};
      var keys = Object.keys(properties).filter(function (key) {
        return key.indexOf('_evey') === 0;
      });
      if (!keys.length) return 0;
      var counts = [];
      var indexes = new Set();
      keys.forEach(function (key) {
        var count = countEntries(properties[key]);
        if (count > 0) counts.push(count);
        var match =
          key.match(/(?:attendee|guest|ticket|registration|entry|pass|evey)[^\d]*(\d+)/i) ||
          key.match(/[\[\._-](\d+)(?:[\]\._-]|$)/);
        if (match && match[1]) indexes.add(match[1]);
      });
      if (indexes.size > 0) counts.push(indexes.size);
      if (counts.length) return Math.max.apply(null, counts);
      return Number((item && item.quantity) || 1);
    }

    function cartNeedsEvey(cart) {
      var events = ((cart && cart.items) || []).filter(isEventItem);
      if (!events.length) return false;
      return !events.every(function (item) {
        return completedCount(item) >= Number(item.quantity || 1);
      });
    }

    function getRows(context) {
      var rows = Array.from(context.root.querySelectorAll(ROW_SELECTOR)).filter(function (row) {
        return row.querySelector('quantity-input, .quantity, ' + QTY_INPUT_SELECTOR);
      });
      return rows.filter(function (row) {
        return !rows.some(function (other) {
          return other !== row && other.contains(row);
        });
      });
    }

    function lineIndex(row, context) {
      var match = (row.id || '').match(/(?:CartItem|CartDrawer-Item)-(\d+)/i);
      if (match) return Number(match[1]) - 1;
      var data = row.getAttribute('data-index') || row.getAttribute('data-line');
      if (data && !Number.isNaN(Number(data))) return Number(data) - 1;
      return getRows(context).indexOf(row);
    }

    function steppers(row) {
      return Array.from(row.querySelectorAll(STEPPER_SELECTOR)).filter(function (button) {
        return !button.closest('cart-remove-button');
      });
    }

    function applyLimitedUi(cart) {
      var items = (cart && cart.items) || [];
      getContexts().forEach(function (context) {
        getRows(context).forEach(function (row) {
          var item = items[lineIndex(row, context)];
          var limited = Boolean(item && isLimitedItem(item));
          row.classList.toggle('evey-limited-row', limited);
          steppers(row).forEach(function (button) {
            if (limited) {
              button.disabled = true;
              button.classList.add('evey-limited-stepper-disabled');
              button.setAttribute('aria-disabled', 'true');
              button.setAttribute('title', strings.guard_max_one || '');
              button.setAttribute('data-evey-limited-ui', 'true');
            } else if (button.getAttribute('data-evey-limited-ui') === 'true') {
              button.disabled = false;
              button.classList.remove('evey-limited-stepper-disabled');
              button.removeAttribute('aria-disabled');
              button.removeAttribute('title');
              button.removeAttribute('data-evey-limited-ui');
            }
          });
          row.querySelectorAll(QTY_INPUT_SELECTOR).forEach(function (input) {
            if (limited) {
              input.setAttribute('max', '1');
              input.readOnly = true;
              input.classList.add('evey-limited-input');
              input.setAttribute('data-evey-limited-ui', 'true');
            } else if (input.getAttribute('data-evey-limited-ui') === 'true') {
              input.removeAttribute('max');
              input.readOnly = false;
              input.classList.remove('evey-limited-input');
              input.removeAttribute('data-evey-limited-ui');
            }
          });
        });
      });
    }

    function placement(context, button) {
      var ctas = button.closest('.cart__ctas');
      if (ctas && ctas.parentElement && context.root.contains(ctas)) return { parent: ctas.parentElement, before: ctas };
      var footer = button.closest(FOOTER_SELECTOR);
      if (footer && context.root.contains(footer)) {
        var footerCtas = footer.querySelector('.cart__ctas');
        if (footerCtas && footerCtas.parentElement) return { parent: footerCtas.parentElement, before: footerCtas };
        return { parent: footer, before: button };
      }
      return { parent: button.parentElement, before: button };
    }

    function renderWarning(context) {
      var buttons = getCheckoutButtons(context);
      var button = buttons.find(isVisible) || buttons[0];
      if (!button) return;
      var warning = document.getElementById(context.warningId);
      if (!warning) {
        warning = document.createElement('div');
        warning.id = context.warningId;
        warning.className = 'evey-attendee-warning';
        warning.setAttribute('role', 'alert');
        warning.setAttribute('aria-live', 'polite');
        warning.innerHTML =
          '<div class="evey-attendee-warning__icon" aria-hidden="true">!</div>' +
          '<div class="evey-attendee-warning__content">' +
          '<p class="evey-attendee-warning__title"></p>' +
          '<p class="evey-attendee-warning__message"></p>' +
          '<a href="#" class="evey-attendee-warning__button"></a>' +
          '</div>';
      }
      var action = warning.querySelector('.evey-attendee-warning__button');
      warning.querySelector('.evey-attendee-warning__title').textContent = strings.guard_title || '';
      warning.querySelector('.evey-attendee-warning__message').textContent = strings.guard_message || '';
      action.textContent = strings.guard_action || '';
      action.removeAttribute('aria-busy');
      action.onclick = function (event) {
        event.preventDefault();
        event.stopPropagation();
        openEveyModal(event.currentTarget);
      };
      var target = placement(context, button);
      if (target.parent && warning.nextElementSibling !== target.before) {
        target.parent.insertBefore(warning, target.before || button);
      }
    }

    function setBlocked(button, blocked) {
      button.classList.toggle('evey-checkout-disabled', blocked);
      if (blocked) {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-evey-blocked', 'true');
      } else {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('data-evey-blocked');
      }
    }

    function applyCheckoutState(blocked) {
      checkoutBlocked = Boolean(blocked);
      var contexts = getContexts();
      contexts.forEach(function (context) {
        getCheckoutButtons(context).forEach(function (button) {
          setBlocked(button, checkoutBlocked);
        });
        if (checkoutBlocked) {
          renderWarning(context);
        } else {
          var warning = document.getElementById(context.warningId);
          if (warning) warning.remove();
        }
      });
      if (checkoutBlocked && !contexts.length) {
        document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (button) {
          setBlocked(button, true);
        });
      }
    }

    function applyUi(cart) {
      applyLimitedUi(cart);
      applyCheckoutState(cartNeedsEvey(cart));
      ensureObservers();
    }

    function maybeFinishNavigation(cart) {
      if (!finishIntentAt || autoNavigated) return;
      var elapsed = Date.now() - finishIntentAt;
      if (elapsed > 60000) {
        finishIntentAt = 0;
        return;
      }
      if (!((cart && cart.items) || []).some(isEventItem) || cartNeedsEvey(cart) || elapsed < 2000) return;
      var themeGated = Array.from(
        document.querySelectorAll('button[name="checkout"], #CartDrawer-Checkout, #checkout, .cart__checkout-button')
      ).some(function (button) {
        return button.disabled;
      });
      var agreement = document.getElementById('agreementCheckbox');
      if (themeGated || (agreement && !agreement.checked)) {
        finishIntentAt = 0;
        return;
      }
      autoNavigated = true;
      window.location.href = CHECKOUT_URL;
    }

    function checkCart() {
      if (checkingCart) return;
      checkingCart = true;
      getCart()
        .then(function (cart) {
          latestCart = cart;
          applyUi(cart);
          maybeFinishNavigation(cart);
        })
        .finally(function () {
          checkingCart = false;
        });
    }

    function scheduleCheck(delay) {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(checkCart, typeof delay === 'number' ? delay : 200);
    }

    function scheduleCheckBurst() {
      scheduleCheck(120);
      [450, 900, 1600].forEach(function (delay) {
        window.setTimeout(checkCart, delay);
      });
    }

    function startTemporaryPolling(duration) {
      var endAt = Date.now() + duration;
      (function poll() {
        window.setTimeout(function () {
          if (Date.now() > endAt || !checkoutBlocked || document.hidden) return;
          checkCart();
          poll();
        }, 1500);
      })();
    }

    function ensureObservers() {
      getContexts().forEach(function (context) {
        if (observedRoots.has(context.root)) return;
        observedRoots.add(context.root);
        new MutationObserver(function () {
          window.clearTimeout(observerTimer);
          observerTimer = window.setTimeout(function () {
            if (checkoutBlocked) applyCheckoutState(true);
            if (latestCart) applyLimitedUi(latestCart);
          }, 150);
        }).observe(context.root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'open', 'aria-hidden', 'hidden', 'disabled']
        });
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        if (!event.isTrusted || event.target.closest('.evey-attendee-warning, ' + EVEY_MODAL_SELECTOR)) return;
        var button = event.target.closest(CHECKOUT_SELECTOR);
        if (!button) return;
        if (!checkoutBlocked && button.getAttribute('data-evey-blocked') !== 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        scheduleCheckBurst();
        var context = getContextForElement(button);
        if (!context) return;
        renderWarning(context);
        var warning = document.getElementById(context.warningId);
        if (warning) warning.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var modal = event.target.closest(EVEY_MODAL_SELECTOR);
        if (modal) {
          var button = event.target.closest('button, [role="button"], input[type="submit"]');
          if (!button) return;
          var label = ((button.textContent || '') + ' ' + (button.getAttribute('aria-label') || '')).toLowerCase();
          if (/(cerrar|close)/.test(label) || label.replace(/\s/g, '').length <= 1) return;
          if (
            button.getAttribute('type') === 'submit' ||
            /(finalizar|checkout|pagar|payer|kasse|cassa|pagamento|continuar|continue|complete)/.test(label)
          ) {
            finishIntentAt = Date.now();
            autoNavigated = false;
            scheduleCheckBurst();
          }
          return;
        }
        if (
          event.target.closest(
            'button[name="add"], .product-form__submit, [data-add-to-cart], ' +
              STEPPER_SELECTOR +
              ', cart-remove-button, [href*="/cart/change"]'
          )
        ) {
          scheduleCheckBurst();
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (form && form.matches && (form.matches('form[action*="/cart/add"]') || form.closest('product-form'))) {
          scheduleCheckBurst();
        }
      },
      true
    );

    document.addEventListener(
      'change',
      function (event) {
        if (event.target.matches && (event.target.matches(QTY_INPUT_SELECTOR) || event.target.closest('.quantity'))) {
          scheduleCheckBurst();
        }
      },
      true
    );

    [
      'cart:updated',
      'cart:change',
      'cart:refresh',
      'cart-drawer:open',
      'evey:updated',
      'evey:attendees:updated',
      'evey:modal:close'
    ].forEach(function (name) {
      document.addEventListener(name, scheduleCheckBurst);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCheckBurst);
    }

    var CART_REQUEST = /\/cart\/(add|change|update|clear)/;
    var originalFetch = window.fetch;
    if (originalFetch) {
      window.fetch = function (resource) {
        var url = String((resource && (resource.url || resource)) || '');
        var result = originalFetch.apply(this, arguments);
        if (CART_REQUEST.test(url) && result && result.then) {
          result.then(scheduleCheckBurst, function () {});
        }
        return result;
      };
    }
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_REQUEST.test(String(url || ''))) this.addEventListener('loadend', scheduleCheckBurst);
      return originalOpen.apply(this, arguments);
    };

    window.fmEveyGuard.refresh = checkCart;
    window.fmEveyGuard.openModal = openEveyModal;
    window.eveyGuardRefresh = checkCart;
    window.eveyGuardOpenModal = openEveyModal;
    checkCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
